"use client";
import { jsxs as c, Fragment as C, jsx as e } from "react/jsx-runtime";
import { InkeepEmbeddedSearchAndChatImpl as g } from "./embedded-search-and-chat.js";
import { useWidgetImpl as I } from "./embedded-search-and-chat.impl.js";
import { InkeepEmbeddedSearchImpl as y } from "./embedded-search.js";
import { Shadow as k, RootProvider as K, WebWidgetInteractionType as u, SearchBar as r } from "@inkeep/cxkit-styled";
import { InkeepModal as b } from "./modal.js";
import { composeEventHandlers as w } from "../utils.js";
import { useControllableState as A } from "@radix-ui/react-use-controllable-state";
function M(n) {
  const {
    modalSettings: t,
    defaultView: o = "search",
    canToggleView: a = !0,
    ...i
  } = n, s = {
    ...i,
    shouldShowAskAICard: a ? n.shouldShowAskAICard : !1
  }, { config: d, ...l } = I({
    ...s,
    defaultView: o
  }), f = (m) => {
    t?.isOpen === void 0 && (n.forceDefaultView && !m && l.setView(o), h(!!m));
  }, [S = !1, h] = A({
    prop: t?.isOpen,
    defaultProp: !1,
    onChange: w(t?.onOpenChange, f)
  }), p = {
    shortcutKey: "k",
    ...t,
    isOpen: S,
    onOpenChange: h
  }, B = () => a ? /* @__PURE__ */ e(g, { ...l }) : /* @__PURE__ */ e(y, { ...s });
  return /* @__PURE__ */ c(C, { children: [
    /* @__PURE__ */ e(k, { wrapperStyles: { display: "contents" }, children: /* @__PURE__ */ e(K, { config: d, componentType: u.SearchBar, children: /* @__PURE__ */ e(O, { onOpenChange: h, modalSettings: p }) }) }),
    /* @__PURE__ */ e(
      b,
      {
        ...d,
        modalSettings: p,
        componentType: u.SearchBar,
        children: B()
      }
    )
  ] });
}
function O({ onOpenChange: n, modalSettings: t }) {
  const o = (a) => {
    a.button !== 2 && n((i) => !i);
  };
  return /* @__PURE__ */ e(r.SearchBarContainer, { children: /* @__PURE__ */ c(r.SearchBarButton, { onClick: o, children: [
    /* @__PURE__ */ c(r.SearchBarContentWrapper, { children: [
      /* @__PURE__ */ e(r.SearchBarIcon, {}),
      /* @__PURE__ */ e(r.SearchBarText, {})
    ] }),
    /* @__PURE__ */ c(r.SearchBarKbdWrapper, { children: [
      /* @__PURE__ */ e(r.SearchBarKbdModifier, { shortcutKey: t?.shortcutKey }),
      /* @__PURE__ */ e(r.SearchBarKbdShortcutKey, { shortcutKey: t?.shortcutKey })
    ] })
  ] }) });
}
export {
  M as InkeepSearchBar,
  O as SearchBarImpl
};
